export default function isZoomApp () {
  return !!navigator.userAgent.match(/ZoomApps/)
}
